// Simple first-person drawing functions to replace the top-down view

export function drawFirstPersonWorkspace(scene) {
  const g = scene.add.graphics();
  
  // === BACK WALL (what you see across from you) ===
  g.fillStyle(0x8B7355);
  g.fillRect(0, 0, 800, 250);
  
  // Menu board on back wall
  g.fillStyle(0x2C2C2C);
  g.fillRect(300, 50, 200, 150);
  g.fillStyle(0xF5DEB3);
  scene.add.text(400, 70, 'MENU', { fontSize: '16px', fill: '#F5DEB3' }).setOrigin(0.5);
  scene.add.text(400, 100, 'Espresso  $3.50\nLatte       $5.50\nCappuccino $5.50', {
    fontSize: '12px',
    fill: '#FFFFFF',
    align: 'center'
  }).setOrigin(0.5);
  
  // Window (left side)
  g.fillStyle(0x87CEEB);
  g.fillRect(50, 40, 180, 160);
  g.lineStyle(4, 0x3E2723);
  g.strokeRect(50, 40, 180, 160);
  
  // === COUNTER TOP (your workspace in front of you) ===
  g.fillStyle(0x8B5A2B);
  g.fillRect(0, 250, 800, 100);
  
  // Counter edge
  g.fillStyle(0xA0522D);
  g.fillRect(0, 250, 800, 8);
  
  // === FLOOR (below counter) ===
  g.fillStyle(0x3D2914);
  g.fillRect(0, 350, 800, 250);
  
  // === WORKSPACE ITEMS (on your counter) ===
  // Coffee machine (right side)
  drawCoffeeMachineFirstPerson(scene, 600, 260);
  
  // Cup stack (left side)
  drawCupStack(scene, 150, 270);
  
  // Register/cash box (center-left)
  g.fillStyle(0x2C2C2C);
  g.fillRect(250, 265, 80, 60);
  g.fillStyle(0x4CAF50);
  scene.add.text(290, 285, '$', { fontSize: '24px', fill: '#4CAF50' }).setOrigin(0.5);
}

function drawCoffeeMachineFirstPerson(scene, x, y) {
  const g = scene.add.graphics();
  
  // Machine body
  g.fillStyle(0x2C2C2C);
  g.fillRect(x, y, 120, 80);
  
  // Chrome details
  g.fillStyle(0x888888);
  g.fillCircle(x + 30, y + 40, 15);
  g.fillCircle(x + 90, y + 40, 15);
  
  // Display
  g.fillStyle(0x001a00);
  g.fillRect(x + 40, y + 10, 40, 20);
  g.fillStyle(0x00FF00);
  scene.add.text(x + 60, y + 20, 'ON', { fontSize: '10px', fill: '#00FF00' }).setOrigin(0.5);
}

function drawCupStack(scene, x, y) {
  const g = scene.add.graphics();
  
  // Stack of cups
  for (let i = 0; i < 3; i++) {
    g.fillStyle(0xFFFFF0);
    g.fillRect(x + i * 5, y - i * 10, 20, 15);
    g.fillStyle(0xE8E8E8);
    g.fillRect(x + 2 + i * 5, y + 2 - i * 10, 16, 11);
  }
}

export function drawCustomerFirstPerson(scene, npc) {
  // Draw customer standing at counter using their portrait sprite
  const container = scene.add.container(400, 180);
  
  // Use the trimmed portrait sprite instead of procedural graphics
  const spriteKey = `portrait-${npc.id}-neutral`;
  
  if (scene.textures.exists(spriteKey)) {
    // Use real portrait
    const sprite = scene.add.sprite(0, -40, spriteKey);
    sprite.setScale(0.25); // Smaller scale for the counter view
    container.add(sprite);
  } else {
    // Fallback to simple graphics if sprite not loaded
    const g = scene.add.graphics();
    container.add(g);
    
    const color = npc.color || 0xE8B86D;
    
    // Simple head
    g.fillStyle(0xE8BEAC);
    g.fillCircle(0, -60, 35);
    
    // Hair
    g.fillStyle(npc.hairColor || 0x4A3728);
    g.beginPath();
    g.arc(0, -70, 35, Math.PI, 0, false);
    g.fill();
    
    // Eyes
    g.fillStyle(0xFFFFFF);
    g.fillCircle(-12, -65, 6);
    g.fillCircle(12, -65, 6);
    g.fillStyle(0x333333);
    g.fillCircle(-12, -65, 3);
    g.fillCircle(12, -65, 3);
    
    // Smile
    g.lineStyle(3, 0x8B5A5A);
    g.beginPath();
    g.arc(0, -55, 10, 0.3, Math.PI - 0.3, false);
    g.strokePath();
    
    // Shoulders/torso
    g.fillStyle(color);
    g.fillRect(-45, -25, 90, 80);
  }
  
  // Name tag
  const nameText = scene.add.text(0, 90, npc.name, {
    fontSize: '14px',
    fill: '#FFD700',
    stroke: '#000',
    strokeThickness: 2,
    fontStyle: 'bold'
  }).setOrigin(0.5);
  container.add(nameText);
  
  container.setDepth(30);
  npc.container = container;
  
  return container;
}
